// combatpro/pwa.js
//
// Combat PRO PWA setup, scoped to the /battletracker route. It swaps the document's
// web-app manifest to the Combat PRO manifest and injects the Apple standalone meta
// tags so ONLY Combat PRO installs with its own identity - the shared portal
// public/index.html and public/manifest.json (used by every other VISINVOKE product)
// are left untouched. It also registers the hardened, cache-free service worker under
// the /battletracker scope so the worker never controls the wider portal origin.
//
// setupCombatProPwa() returns a cleanup function that restores the original manifest
// href and removes the injected tags when Combat PRO unmounts. The service worker is
// intentionally NOT unregistered on cleanup: it is scoped to /battletracker and caches
// nothing, so leaving it in place is harmless and avoids registration churn. All DOM /
// SW work is wrapped so a failure can never break Combat PRO rendering. No optional
// chaining. No em dash.

export function setupCombatProPwa() {
  if (typeof document === 'undefined') { return function () {}; }
  var head = document.head;
  var created = [];
  var prevManifestHref = null;

  var manifestLink = head.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    prevManifestHref = manifestLink.getAttribute('href');
    manifestLink.setAttribute('href', '/combatpro.webmanifest');
  } else {
    manifestLink = document.createElement('link');
    manifestLink.setAttribute('rel', 'manifest');
    manifestLink.setAttribute('href', '/combatpro.webmanifest');
    head.appendChild(manifestLink);
    created.push(manifestLink);
  }

  var metas = [
    ['apple-mobile-web-app-capable', 'yes'],
    ['apple-mobile-web-app-status-bar-style', 'black-translucent'],
    ['apple-mobile-web-app-title', 'Combat PRO'],
    ['mobile-web-app-capable', 'yes']
  ];
  for (var i = 0; i < metas.length; i++) {
    var el = document.createElement('meta');
    el.setAttribute('name', metas[i][0]);
    el.setAttribute('content', metas[i][1]);
    el.setAttribute('data-combatpro-pwa', '1');
    head.appendChild(el);
    created.push(el);
  }

  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/combatpro-sw.js', { scope: '/battletracker' })
        .catch(function () {});
    }
  } catch (e) { /* non-fatal */ }

  return function cleanup() {
    if (prevManifestHref !== null && manifestLink) {
      manifestLink.setAttribute('href', prevManifestHref);
    }
    for (var j = 0; j < created.length; j++) {
      var node = created[j];
      if (node && node.parentNode) { node.parentNode.removeChild(node); }
    }
  };
}
